// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"294":"8e28e371","426":"2af6e282","961":"2734c010"}[chunkId] + ".chunk.css";
};